module.exports = __webpack_public_path__ + "media/application/images/icons/linkedin-footer-df0578269fa99bd184994969a27123f3.svg";